/* Rodus Professional — theme.js */
(function () {
  'use strict';

  /* ─── Sticky header ─────────────────────────────── */
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ─── Mobile drawer ─────────────────────────────── */
  var navToggle = document.querySelector('.nav-toggle');
  var drawer = document.getElementById('mobile-drawer');
  var closeEls = document.querySelectorAll('[data-drawer-close]');

  if (navToggle && drawer) {
    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      navToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      navToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    navToggle.addEventListener('click', openDrawer);
    closeEls.forEach(function (el) { el.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ─── Product gallery ───────────────────────────── */
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  var mainImg = document.querySelector('.product-gallery__main');
  if (thumbs.length && mainImg) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        mainImg.src = thumb.getAttribute('data-full') || thumb.src;
      });
    });
  }


  /* ─── Mobile nav accordion ─────────────────────── */
  document.querySelectorAll('.mobile-nav__toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var submenu = btn.nextElementSibling;
      var isOpen = btn.classList.contains('is-open');
      // Sluit alle andere open submenus
      document.querySelectorAll('.mobile-nav__toggle.is-open').forEach(function(other) {
        other.classList.remove('is-open');
        other.setAttribute('aria-expanded', 'false');
        if (other.nextElementSibling) other.nextElementSibling.classList.remove('is-open');
      });
      // Toggle huidige
      if (!isOpen) {
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        if (submenu) submenu.classList.add('is-open');
      }
    });
  });


  /* ─── Solutions slider ──────────────────────────── */
  document.querySelectorAll('[id^="solutions-track-"]').forEach(function(track) {
    var suffix = track.id.replace('solutions-track-', '');
    var grid = document.getElementById('solutions-grid-' + suffix);
    var prevBtn = document.getElementById('solutions-prev-' + suffix);
    var nextBtn = document.getElementById('solutions-next-' + suffix);
    var counter = document.getElementById('solutions-counter-' + suffix);
    var dotsWrap = document.getElementById('solutions-dots-' + suffix);
    if (!prevBtn || !nextBtn) return;

    var cards = track.querySelectorAll('.solution-card');
    var total = cards.length;
    var current = 0;

    function isMobile() { return window.innerWidth <= 768; }

    function goTo(index) {
      if (isMobile()) return; // mobiel = native scroll; JS-transform uit
      current = Math.max(0, Math.min(index, total - 1));
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (counter) counter.textContent = (current + 1) + ' / ' + total;
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current === total - 1;
      if (dotsWrap) {
        dotsWrap.querySelectorAll('.solutions__dot').forEach(function(dot, i) {
          dot.classList.toggle('active', i === current);
        });
      }
    }

    prevBtn.addEventListener('click', function() { goTo(current - 1); });
    nextBtn.addEventListener('click', function() { goTo(current + 1); });

    if (dotsWrap) {
      dotsWrap.querySelectorAll('.solutions__dot').forEach(function(dot, i) {
        dot.addEventListener('click', function() { goTo(i); });
      });
    }

    // Touch/swipe
    var startX = 0;
    track.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function(e) {
      if (!isMobile()) return;
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });

    window.addEventListener('resize', function() { goTo(current); });
    goTo(0);
  });

})();
